import { CmmImInfo } from '../../../../roadmap/components/go/CmmImInfo';

export default function ImInfoScreen() {
    return <CmmImInfo />;
}
